import React from 'react'
import PropTypes from 'prop-types'
import FlipMove from 'react-flip-move'

import Styles from '../styles/components/grid.module.scss'

class GridItem extends React.PureComponent {
  render() {
    const { className, size } = this.props
    const classNames = [Styles[`gridItem--${size}`]]

    if (className) {
      classNames.push(className)
    }

    return (
      <div className={classNames.join(' ')}>
        <div className={Styles.gridItemContentWrapper}>
          <div className={Styles.gridItemContent}>{this.props.children}</div>
        </div>
      </div>
    )
  }
}

GridItem.propTypes = {
  size: PropTypes.string.isRequired,
  className: PropTypes.string,
}

GridItem.defaultProps = {
  size: '1x1',
}

class Grid extends React.PureComponent {
  renderChildren() {
    const { children } = this.props
    const test = []
    // generate rows
    React.Children.forEach(children, child => {
      test.push(child)
    })

    return test
  }
  render() {
    const classes = [Styles.grid]

    if (this.props.className) {
      classes.push(this.props.className)
    }

    return (
      <div className={Styles.container}>
        {this.props.flip ? (
          <FlipMove
            easing="ease-out"
            className={classes.join(' ')}
            duration={250}
            staggerDurationBy={50}
            staggerDelayBy={50}
            onStartAll={() => {
              if (this.props.onFlipStart) {
                this.props.onFlipStart()
              }
            }}
            onFinishAll={() => {
              if (this.props.onFlipFinish) {
                this.props.onFlipFinish()
              }
            }}
          >
            {this.renderChildren()}
          </FlipMove>
        ) : (
          <div className={classes.join(' ')}>{this.props.children}</div>
        )}
      </div>
    )
  }
}

export { Grid, GridItem }



// WEBPACK FOOTER //
// ./src/components/grid.js